module.exports = __webpack_public_path__ + "img/金融风控.10674b4e.png";